import { render } from "./roadRescue.vue?vue&type=template&id=50e61624"
import script from "./roadRescue.vue?vue&type=script&lang=js"
export * from "./roadRescue.vue?vue&type=script&lang=js"

import "./roadRescue.vue?vue&type=style&index=0&id=50e61624&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__